import styled from "@emotion/styled";
import { colors } from "src/theme";
import { Text } from "../typography";
import { getStepConfig } from "src/pages/app/_router/app.routes";
import { useLocation } from "react-router-dom";
import { i18n, mediaQuery } from "src/common";

const HeaderSection = styled.div({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '8px 8px 0 0',
  padding: '24px 0',
  [mediaQuery('laptopL')]: {
    paddingTop: '44px',
  },
});

const TitleStyle = styled(Text)({
});

const SubtitleStyle = styled(Text)({
  color: colors.text3,
});

const DisclaimerStyle = styled(Text)({
  color: colors.text3,
  fontStyle: 'italic',
});

export const StepHeader = () => {
  const { pathname } = useLocation();
  const stepConfig = getStepConfig(pathname);
  if (!stepConfig) return;

  return (
    <HeaderSection>
      { stepConfig?.title && <TitleStyle type="large" bold>{i18n.t(stepConfig?.title)}</TitleStyle>}
      {stepConfig.subtitle && (
        <SubtitleStyle type="small">{i18n.t(stepConfig.subtitle)}</SubtitleStyle>
      )}
      { stepConfig.disclaimer && (
        <DisclaimerStyle type="tiny">{i18n.t(stepConfig.disclaimer)}</DisclaimerStyle>
      )}
    </HeaderSection>
  )
};
